import { a as _slicedToArray, d as _objectSpread2, j as _asyncToGenerator, k as _regeneratorRuntime } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { u as useKeyPress, a as useComponentVisible } from './useKeyPress-dea8da08.js';
import { I as Icon } from './index-11bc5ac3.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import Input from './Input.js';
import LoadingBlock from './LoadingBlock.js';
import './_commonjsHelpers-17042db9.js';
import 'moment';

function SearchInputResultItem(props) {
  var active = props.active,
    icon = props.icon,
    mainText = props.mainText,
    secondaryText = props.secondaryText,
    onClick = props.onClick,
    item = props.item,
    setHovered = props.setHovered;
  var enterPress = useKeyPress('Enter');
  useEffect(function () {
    if (enterPress && active) {
      onClick(item);
    }
  }, [enterPress, item, onClick, active]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-item-wrapper ".concat(active ? 'active' : ''),
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setHovered(item);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(undefined);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-item-icon-wrapper"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: icon
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-item-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-item-main-text"
  }, mainText), secondaryText ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-item-secondary-text"
  }, secondaryText) : null));
}
SearchInputResultItem.defaultProps = {
  secondaryText: ''
};
SearchInputResultItem.propTypes = {
  /**
  Handle the active element className
   */
  active: PropTypes.bool.isRequired,
  /**
  Results category icon
   */
  icon: PropTypes.string.isRequired,
  /**
  Result text
   */
  mainText: nodeOrStringProp.isRequired,
  /**
  Result text
   */
  secondaryText: nodeOrStringProp,
  /**
  Function that handle the click event
   */
  onClick: PropTypes.func.isRequired,
  /**
  Result item
   */
  item: PropTypes.shape().isRequired,
  /**
  Handle the mouseover/mouseout event
   */
  setHovered: PropTypes.func.isRequired
};

function SearchInputResultCategory(props) {
  var categoryName = props.categoryName,
    items = props.items,
    onClick = props.onClick,
    setUserInput = props.setUserInput,
    setHovered = props.setHovered,
    totalElements = props.totalElements,
    hovered = props.hovered,
    icon = props.icon;
  var downPress = useKeyPress('ArrowDown');
  var upPress = useKeyPress('ArrowUp');
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    cursor = _useState2[0],
    setCursor = _useState2[1];

  // The functions below handle the key events for options navigation.

  useEffect(function () {
    if (totalElements && downPress) {
      setCursor(function (prevState) {
        return prevState < totalElements - 1 ? prevState + 1 : prevState;
      });
    }
  }, [downPress, totalElements]);
  useEffect(function () {
    if (totalElements && upPress) {
      setCursor(function (prevState) {
        return prevState > 0 ? prevState - 1 : prevState;
      });
    }
  }, [totalElements, upPress]);
  useEffect(function () {
    if (totalElements && hovered) {
      setCursor(items.indexOf(hovered));
    }
  }, [hovered, items, totalElements]);
  var buildResultItemIcon = function buildResultItemIcon(type) {
    return "bf-icon-".concat(type);
  };
  var buildSecondaryText = function buildSecondaryText(type, subtitle) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "bf-subtitle-".concat(type)
    }, subtitle);
  };
  function handleItemClick(item) {
    onClick(item);
    setUserInput('');
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-category-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-category-name"
  }, categoryName), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-result-category-items-wrapper"
  }, items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(SearchInputResultItem, {
      active: item.id === cursor,
      icon: buildResultItemIcon(icon),
      mainText: item.title,
      secondaryText: buildSecondaryText(item.type, item.subtitle),
      key: item.id,
      item: item,
      onClick: function onClick() {
        return handleItemClick(item);
      },
      setHovered: setHovered
    });
  })));
}
SearchInputResultCategory.defaultProps = {
  hovered: undefined,
  icon: '',
  categoryName: []
};
SearchInputResultCategory.propTypes = {
  /**
  Results category name
   */
  categoryName: nodeOrStringProp,
  /**
  Result items
   */
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  /**
  Function that handle the click event
   */
  onClick: PropTypes.func.isRequired,
  /**
  Takes the value of the selected element and puts it in the placeholder
   */
  setUserInput: PropTypes.func.isRequired,
  /**
  Handle the mouseover/mouseout event
   */
  setHovered: PropTypes.func.isRequired,
  /**
  Handle the mouseover/mouseout event
   */
  hovered: PropTypes.shape(),
  /**
  Total number of elements in array options
   */
  totalElements: PropTypes.number.isRequired,
  /**
  Handle the icon type of the elements
   */
  icon: PropTypes.string
};

var googleLogo = "data:image/png;base64,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";

function SearchInput(props) {
  var className = props.className,
    disabled = props.disabled,
    intlNotFindMessage = props.intlNotFindMessage,
    onChange = props.onChange,
    onFilterProperties = props.onFilterProperties,
    placeholder = props.placeholder,
    resetFilterApplied = props.resetFilterApplied,
    onFilterApplied = props.onFilterApplied,
    autocompleteFilterApplied = props.autocompleteFilterApplied,
    categoriesLabels = props.categoriesLabels,
    clearIcon = props.clearIcon,
    filterOnClick = props.filterOnClick,
    onGetPlace = props.onGetPlace;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSuggestions = _useState4[0],
    setShowSuggestions = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    suggestions = _useState6[0],
    setSuggestions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showNoResultMessage = _useState8[0],
    setShowNoResultMessage = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    userInput = _useState10[0],
    setUserInput = _useState10[1];
  var _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2),
    hovered = _useState12[0],
    setHovered = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isOnFocus = _useState14[0],
    setIsOnFocus = _useState14[1];
  var escapePress = useKeyPress('Escape');
  var inputRef = useRef(null);
  var hasFilterApplied = !!autocompleteFilterApplied;
  function cleanOldValues() {
    setSuggestions(undefined);
    setShowNoResultMessage(false);
  }
  function handleOnChange(value) {
    // set value to the input
    setUserInput(value);

    // clean old values
    cleanOldValues();
    if (!value.trim()) {
      return false;
    }

    // start loading
    setIsLoading(true);
    return onChange(value.trim()).then(function (result) {
      var _result$categories;
      setShowSuggestions(true);
      if (!(result === null || result === void 0 ? void 0 : (_result$categories = result.categories) === null || _result$categories === void 0 ? void 0 : _result$categories.length)) {
        // no results
        setShowNoResultMessage(true);
      } else {
        // positive results
        setSuggestions(result);
      }
      // end loading
      return setIsLoading(false);
    }).catch(function () {
      return setShowNoResultMessage(true);
    });
  }
  var handleClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
      var title, subtitle, value, label, place, _place$location, latitude, longitude, distance;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            title = item.title, subtitle = item.subtitle;
            value = item.value;
            label = title;
            if (!item.isGooglePlace) {
              _context.next = 10;
              break;
            }
            _context.next = 6;
            return onGetPlace(item.value, item.type);
          case 6:
            place = _context.sent;
            _place$location = place.location, latitude = _place$location.latitude, longitude = _place$location.longitude, distance = place.distance;
            value = {
              latitude: latitude,
              longitude: longitude,
              distance: distance
            };
            label = subtitle;
          case 10:
            if (filterOnClick) {
              onFilterProperties(value, item.type);
            }
            setIsOnFocus(false);
            setShowSuggestions(false);
            if (filterOnClick) {
              onFilterApplied(label, item);
            } else {
              onFilterApplied(item, item);
            }
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var removeFilter = function removeFilter() {
    resetFilterApplied();
    setShowSuggestions(false);
    onFilterApplied(null);
  };
  var handleClickOutside = function handleClickOutside() {
    setShowSuggestions(false);
    setIsLoading(false);
    setIsOnFocus(false);
    setUserInput('');
  };
  var _useComponentVisible = useComponentVisible(false, handleClickOutside),
    ref = _useComponentVisible.ref,
    setIsComponentVisible = _useComponentVisible.setIsComponentVisible;
  var clearSearchInput = function clearSearchInput() {
    if (!userInput) {
      removeFilter();
    }
    inputRef.current.focus();
    setUserInput('');
    setShowSuggestions(false);
    setIsLoading(false);
  };
  var hasSuggestions = (suggestions === null || suggestions === void 0 ? void 0 : suggestions.categories) && suggestions.categories.length > 0;
  var handleSearchInputFocus = function handleSearchInputFocus() {
    setIsOnFocus(true);
    setIsComponentVisible(true);
    if (userInput) {
      setShowSuggestions(true);
    }
  };
  useEffect(function () {
    if (escapePress) {
      setUserInput('');
      setShowSuggestions(false);
      setIsLoading(false);
    }
  }, [escapePress]);

  // arrowsHandler prevents default browser behavior when arrowUp and arrowDown were pressed

  var arrowsHandler = function arrowsHandler(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  };
  useEffect(function () {
    var refCurrent = ref.current || {};
    refCurrent.addEventListener('keydown', arrowsHandler, false);
    return function () {
      return (// cleanup
        refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.removeEventListener('keydown', arrowsHandler, false)
      );
    };
  }, [ref]);
  function LoadingStateCategory() {
    return /*#__PURE__*/React__default.createElement(LoadingBlock, {
      className: "bf-search-input-loading-results-category-title",
      width: "25%",
      height: "15px"
    });
  }
  var LoadingStateItem = function LoadingStateItem() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bf-search-input-loading-result-item-wrapper"
    }, /*#__PURE__*/React__default.createElement(LoadingBlock, {
      className: "bf-search-input-loading-result-item-icon"
    }), /*#__PURE__*/React__default.createElement(LoadingBlock, {
      className: "bf-search-input-loading-result-item-main-text"
    }), /*#__PURE__*/React__default.createElement(LoadingBlock, {
      className: "bf-search-input-loading-result-item-secondary-text",
      width: "50%",
      height: "10px"
    }));
  };
  var elementsInSuggestionsCounter = 0;
  function addIdToSuggestions(arr) {
    var addIdToChildrenArray = function addIdToChildrenArray(children) {
      return children.map(function (child) {
        var newChildWithId = _objectSpread2(_objectSpread2({}, child), {}, {
          id: elementsInSuggestionsCounter
        });
        elementsInSuggestionsCounter++;
        return newChildWithId;
      });
    };
    return arr.categories.map(function (category) {
      var hasChildren = category.children && !!category.children.length;
      var children = hasChildren ? addIdToChildrenArray(category.children) : [];
      var newCategoriesObjectWithId = _objectSpread2(_objectSpread2({}, category), {}, {
        children: children
      });
      return newCategoriesObjectWithId;
    });
  }
  var suggestionsWithId = hasSuggestions && addIdToSuggestions(suggestions);
  var inputNotEmpty = (showSuggestions || isLoading) && userInput || autocompleteFilterApplied;
  var showResults = (showSuggestions || isLoading) && userInput;
  var inputPlaceholder = hasFilterApplied && isOnFocus ? autocompleteFilterApplied : placeholder;
  var inputValue = hasFilterApplied && !isOnFocus ? autocompleteFilterApplied : userInput;
  var showClearIcon = (userInput || hasFilterApplied) && clearIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-main-wrapper ".concat(className),
    ref: ref
  }, /*#__PURE__*/React__default.createElement(Input, {
    className: "bf-search-input ".concat(inputNotEmpty ? 'is-not-empty' : '', " ").concat(disabled ? 'is-disabled' : ''),
    reference: inputRef,
    disabled: disabled,
    icon: "bf-icon-search",
    iconPosition: "left",
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return handleOnChange(value);
    },
    onFocus: handleSearchInputFocus,
    placeholder: inputPlaceholder,
    value: inputValue
  }), showClearIcon ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-clear-search-trigger-wrapper"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: "bf-search-input-clear-search-trigger",
    name: "bf-icon-times",
    onClick: clearSearchInput
  })) : null, showResults ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-results-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-search-input-results-caret"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-results-content"
  }, hasSuggestions && !isLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, suggestionsWithId.map(function (category) {
    var key = "items_".concat(category.type);
    return /*#__PURE__*/React__default.createElement(SearchInputResultCategory, {
      categoryName: categoriesLabels[category.type],
      items: category.children,
      icon: category.icon,
      onClick: function onClick(item) {
        return handleClick(item);
      },
      setUserInput: setUserInput,
      hovered: hovered,
      setHovered: setHovered,
      totalElements: elementsInSuggestionsCounter,
      key: key
    });
  })) : showNoResultMessage && /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-results-empty-message"
  }, intlNotFindMessage(userInput)), isLoading ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-loading-results-wrapper"
  }, /*#__PURE__*/React__default.createElement(LoadingStateCategory, null), /*#__PURE__*/React__default.createElement(LoadingStateItem, null), /*#__PURE__*/React__default.createElement(LoadingStateItem, null), /*#__PURE__*/React__default.createElement(LoadingStateCategory, null), /*#__PURE__*/React__default.createElement(LoadingStateItem, null), /*#__PURE__*/React__default.createElement(LoadingStateItem, null), /*#__PURE__*/React__default.createElement(LoadingStateItem, null)) : null, (suggestions === null || suggestions === void 0 ? void 0 : suggestions.containsGooglePlaces) ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-input-results-google"
  }, /*#__PURE__*/React__default.createElement("img", {
    loading: "lazy",
    src: googleLogo,
    alt: "powered by Google"
  })) : null)) : null);
}
SearchInput.defaultProps = {
  className: '',
  disabled: false,
  intlNotFindMessage: function intlNotFindMessage() {},
  onChange: function onChange() {},
  onFilterProperties: function onFilterProperties() {},
  placeholder: '',
  resetFilterApplied: function resetFilterApplied() {},
  autocompleteFilterApplied: '',
  onFilterApplied: function onFilterApplied() {},
  categoriesLabels: {},
  clearIcon: true,
  filterOnClick: true,
  onGetPlace: function onGetPlace() {}
};
SearchInput.propTypes = {
  /**
  Handle the input className
   */
  className: PropTypes.string,
  /**
  Lock the input while isLoading
   */
  disabled: PropTypes.bool,
  /**
  Message for no result
   */
  intlNotFindMessage: PropTypes.func,
  /**
  Handle the input onChange event.
   */
  onChange: PropTypes.func,
  /**
  Search the new properties after onClick event
   */
  onFilterProperties: PropTypes.func,
  /**
  Show the userInput information
   */
  placeholder: PropTypes.string,
  /**
  Reset all properties when filter is removed
   */
  resetFilterApplied: PropTypes.func,
  /**
  Set filter applied into the state
   */
  onFilterApplied: PropTypes.func,
  /**
  Filter applied value
   */
  autocompleteFilterApplied: PropTypes.string,
  /**
  Labels for the different categories
   */
  categoriesLabels: PropTypes.shape({}),
  /**
  Show X to clear input
   */
  clearIcon: PropTypes.bool,
  /**
   * Flag to enable filter function after clicking
   */
  filterOnClick: PropTypes.bool,
  /**
   * Callback if google pace flag exists
   */
  onGetPlace: PropTypes.func
};

export default SearchInput;
//# sourceMappingURL=SearchInput.js.map
